import { Injectable, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
// const hostname = document.location.hostname;
// const baseUrl = "https://"+hostname+"/v1/"+apiName;
// const baseUrl = "http://localhost:8000/v1/cs";
const baseUrl = "https://d2zinquiries.com.au"+"/v1/"+"cs";
// const baseUrl = "http://ec2-3-111-171-168.ap-south-1.compute.amazonaws.com:4000/v1/cs";
// const baseUrl = "http://ec2-43-205-239-156.ap-south-1.compute.amazonaws.com:4000/v1/cs";
// const baseUrl = "http://35.154.144.186:8080/v1/cs";
//const baseUrl = "http://18.220.140.225:8080/v1/cs"; 

@Injectable()
export class ConsigmentUploadService implements OnInit {

  public newUserSubject = new Subject<any>();
  userMessage:userMessage;

  constructor(  
      private http: HttpClient, 
      private router: Router
  ){}

  ngOnInit(){}

  getLoginDetails(data){
    this.userMessage = data;
    this.newUserSubject.next(data);
  };

  contactus( ContactObject, callback ): any {
    this.http.get(baseUrl+'/contactUs',{
     params: { email: ContactObject.Email, name: ContactObject.Name ,subject:ContactObject.Subject,message:ContactObject.Message }}
           ).subscribe((resp) => {
             callback(resp);
             if (resp) {
               console.log(resp);
             } else {
                 console.error("Not Found!")
             }
           }, (error) => {
               callback(error);
           });
  };

  authenticate( loginObject, callback): any {
   // console.log(hostname)
    this.http.get(baseUrl+'/login', {
      params: { userName: loginObject.userName, passWord: loginObject.passWord  }
    }).subscribe((resp) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

  CSTrackDetails( status, reference_number, brokerName, callback): any {
    this.http.get(baseUrl+'/csDetails',{
      params: { status: status,  reference_number: reference_number, brokerName: brokerName}
    })
    .subscribe((resp:userMessage) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

  CSTrackDateDetails( status, fromDate, toDate, brokerName, callback): any {
    this.http.get(baseUrl+'/csDetails',{
      params: { status: status,  fromDate: fromDate, toDate:toDate, brokerName: brokerName}
    })
    .subscribe((resp:userMessage) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

  updateCSstatus( csData, callback): any {
    console.log(csData)
    this.http.post(baseUrl+'/csStatus-update',csData)
    .subscribe((resp:userMessage) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };
  
  viewPodFileStatus( articleId, callback): any {
    console.log(articleId)
    this.http.get(baseUrl+'/pod/'+articleId)
    .subscribe((resp:userMessage) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

  csDetailsHist( reference_number, callback): any {
    this.http.get(baseUrl+'/csDetailsHistory', {
      params: { reference_number: reference_number }
    }).subscribe((resp) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

  csDetailsStatusList( status, reference_number, brokerName, callback): any {
    this.http.get(baseUrl+'/csDetailsStatus', {
      params: { status: status, reference_number: reference_number, brokerName: brokerName}
    }).subscribe((resp) => {
      callback(resp);
      if (resp) {
      } else {
        console.error("Not Found!")
      }
    }, (error) => {
      callback(error);
    });
  };

};

export interface userMessage {
  userName,
  password,
  brokerUserName
};







// WEBPACK FOOTER //
// ./src/app/cs/service/consignment-upload.service.ts